import { writable } from 'svelte/store';

export const title_stored = writable("");
export const label_stored = writable([]);
export const data_stored = writable([]);
